export type TransportOrderDetailRowProps = {
    label: string;
    value: string;
    secondaryValue?: string;
};

const TransportOrderDetailRow = ({ label, value, secondaryValue }: TransportOrderDetailRowProps) => (
    <div>
        <div className='text-size-16 text-medium text-color-dark margin-bottom-5'>{label}</div>
        <div className='text-size-14 text-color-dark'>{value}</div>
        {secondaryValue === undefined ? null : <div className='text-size-14 text-color-dark'>{secondaryValue}</div>}
    </div>
);

export default TransportOrderDetailRow;
